export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pureWorker.d66a7ac1.worker.js");
}
